import styled from 'styled-components/macro'
import Box from 'components/shared/Box'

export const DropdownLabel = styled(Box)`
    z-index: 100;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 4px 35px 0 rgba(32, 0, 139, 0.05);
`
